'use strict';

// Latin subsets only, and only the weights the site actually sets: 200 for the
// first constellation's title, 300 for the sidebar name, 400 for body copy,
// 600 for headings and 700 for bold, plus an italic so emphasis in prose is a
// real italic rather than a slanted upright.
require('@fontsource/newsreader/latin-200.css');
require('@fontsource/newsreader/latin-300.css');
require('@fontsource/newsreader/latin-400.css');
require('@fontsource/newsreader/latin-400-italic.css');
require('@fontsource/newsreader/latin-600.css');
require('@fontsource/newsreader/latin-700.css');

require('./src/assets/scss/init.scss');
require('./static/css/prismjs/theme.min.css');

const React = require('react');
const { ThemeProvider } = require('./src/context/ThemeContext');

exports.wrapRootElement = ({ element }) => {
  return React.createElement(ThemeProvider, null, element);
};
